import superagent from 'superagent';

export default async function getParcelTrackingQuerie(
  adminWebservice,
  webservice,
  getCookie,
  parcel,
  guide,
) {
  let url = '';
  let response = {};
  const location = process.env.REACT_APP_COUNTRY;
  webservice = 'https://terramarbrands.mx/wsterramar/Service1.svc';
  adminWebservice = ' https://admin.terramarbrands.mx';

  if (parcel === 'Estafeta') url = `${webservice}/getParcelTracking?guia=${guide}`;
  if (parcel === 'DHL') url = `${adminWebservice}:8083/getParcelTracking?guia=${guide}`;
  if (parcel === 'Paquete Express')
    url = `${adminWebservice}:8083/getParcelTrackingPE?guia=${guide}`;
  await superagent
    .get(url)
    .set('Content-Type', 'application/json')
    .auth(getCookie('TMBcartToken'), (location === 'MX' && {}) || { type: 'bearer' })
    .then((res) => {
      response = res.body;
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
